import { mobileCSS, tabletCSS } from '@measures/responsive'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface TitleProps {
  children: string
}

const StyledTitle = styled.div`
  ${({
    theme: {
      fonts: { goodOTNarrow },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    margin: 0 0 10px 0;
    font-family: ${goodOTNarrow};
    font-size: 56px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.9px;
    line-height: 58px;
    text-align: left;
    color: ${grey_100};
    display: block;
    ${tabletCSS(css`
      font-size: 52px;
      line-height: 56px;
    `)}
    ${mobileCSS(css`
      font-size: 32px;
      line-height: 36px;
    `)}
  `}
`

const Title: FunctionComponent<TitleProps> = ({ children }) => (
  <StyledTitle>{children}</StyledTitle>
)

export default Title
